// Blank skin - no additional styles
const blankSkin = {
  name: 'blank',
  colors: {
    primary: 'inherit',
    secondary: 'inherit',
    accent: 'inherit',
    background: 'inherit',
    text: 'inherit',
  },
  button: {
    background: 'none',
    hover: 'none',
    disabled: 'none',
  },
  components: {}
};

export default blankSkin;
